//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productSetting', {
//        templateUrl: 'views/components/views/productSetting/productSetting.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'productSettingService', 'productService', 'logisticService', 'ttGridFactory', function ($stateParams, stateService, utilityService, productSettingService, productService, logisticService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productSettingKeyno = $stateParams.productsetting_keyno;
            
//            vm.model = {
//                discGroupProductNameButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.discgrpprod_keyno = '0' }
//                ],
//                discGroupProductNameButtons2: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.discgrpprod_keyno = '0' },
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('discgrpprods', {}) }
//                ],
//                prodgrpButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onChanged('', 'prodgrp_id') }
//                ],
//                prodgrp2Buttons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onChanged('', 'prodgrp2_id') }
//                ],
//                prodgrp3Buttons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onChanged('','prodgrp3_id') }
//                ],
//                prodgrp4Buttons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onChanged('', 'prodgrp4_id') }
//                ],
//                edit: {},
//                selectListProductTypes: [],
//                selectListUnits: [],
//                selectListProductGroups: [],
//                selectListProductGroups2: [],
//                selectListProductGroups3: [],
//                selectListProductGroups4: [],
//                selectListCompanies: [],
//                selectListCompletionMethods: [],
//                selectListCompletionPrinciples: [],
//                selectListProductionOrderMethods: [],
//                selectListPlanPolicies: [],
//                selectListDiscGroupProducts: [],
//                selectListProductionPlaces: [],
//                gridReady: false,
//                lockedSave: false,
//                lockedDelete: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'productsetting_productsettingmcs_grid',
//                kendo: {
//                    height: null,
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({
//                wrapping: true
//            }).setCustomToolbarButtons([{
//                name: 'productsettingmc_new',
//                text: 'productsettingmc_new',
//                func: function () {
//                    stateService.go('productsettingmc', {
//                        productsetting_keyno: vm.model.edit.productsetting_keyno,
//                        productsettingmc_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await productSettingService.getEdit({ productsetting_keyno: productSettingKeyno }))[0];
//            }
            
//            async function loadProductTypes() {
//                vm.model.selectListProductTypes = await productService.listProductTypes();
//            }

//            async function loadUnits() {
//                vm.model.selectListUnits = await logisticService.listUnits();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadCompletionMethods() {
//                vm.model.selectListCompletionMethods = await logisticService.listCompletionMethods();
//            }

//            async function loadCompletionPrinciples() {
//                vm.model.selectListCompletionPrinciples = await logisticService.listCompletionPrinciples();
//            }

//            async function loadProductionOrderMethods() {
//                vm.model.selectListProductionOrderMethods = await logisticService.listProductionOrderMethods();
//            }

//            async function loadPlanPolicies() {
//                vm.model.selectListPlanPolicies = await logisticService.listPlanPolicies();
//            }

//            async function loadDiscGroupProducts() {
//                vm.model.selectListDiscGroupProducts = await productService.listDiscGroupProducts();
//            }

//            async function loadProductionPlaces() {
//                vm.model.selectListProductionPlaces = await logisticService.listProductionPlaces();
//            }

//            async function loadProductGroups() {
//                vm.model.selectListProductGroups = await logisticService.listProductGroups();
//            }

//            async function loadProductGroup2s() {
//                if (utilityService.validateParmsValue(vm.model.edit.prodgrp_id) !== true) return;

//                return vm.model.selectListProductGroups2 = await productService.listProductGroup2s({ prodgrp_id: vm.model.edit.prodgrp_id });
//            }

//            async function loadProductGroup3s() {
//                if (utilityService.validateParmsValue(vm.model.edit.prodgrp2_id) !== true) return;

//                return vm.model.selectListProductGroups3 = await productService.listProductGroup3s({ prodgrp2_id: vm.model.edit.prodgrp2_id });
//            }

//            async function loadProductGroup4s() {
//                if (utilityService.validateParmsValue(vm.model.edit.prodgrp3_id) !== true) return;

//                return vm.model.selectListProductGroups4 = await productService.listProductGroup4s({ prodgrp3_id: vm.model.edit.prodgrp3_id });
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.edit.productsetting_keyno) !== true) return;
                
//                vm.grid.dataTask.loadData = {
//                    method: 3061,
//                    parameters: { productsetting_keyno: vm.model.edit.productsetting_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            vm.onChanged = function (value, field) {
//                switch (field) {
//                    case 'prodgrp_id':
//                        if (value === vm.model.edit.prodgrp_id) return;

//                        vm.model.edit.prodgrp_id = value;

//                        if (value > '') {
//                            loadProductGroup2s();
//                        } else {
//                            vm.model.selectListProductGroups2 = [];
//                        }

//                        vm.onChanged('', 'prodgrp2_id');
//                        break;
//                    case 'prodgrp2_id':
//                        if (value === vm.model.edit.prodgrp2_id) return;

//                        vm.model.edit.prodgrp2_id = value;
//                        if (value > '') {
//                            loadProductGroup3s();
//                        } else {
//                            vm.model.selectListProductGroups3 = [];
//                        }

//                        vm.onChanged('', 'prodgrp3_id');
//                        break;
//                    case 'prodgrp3_id':
//                        if (value === vm.model.edit.prodgrp3_id) return;

//                        vm.model.edit.prodgrp3_id = value;

//                        if (value > '') {
//                            loadProductGroup4s();
//                        } else {
//                            vm.model.selectListProductGroups4 = [];
//                        }

//                        vm.onChanged('', 'prodgrp4_id');
//                        break;
//                    case 'prodgrp4_id':
//                        if (value === vm.model.edit.prodgrp4_id) return;

//                        vm.model.edit.prodgrp4_id = value;
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productSettingService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.delete = async function () {
//                if (!vm.model.lockedDelete && vm.model.edit.productsetting_keyno > 0) {
//                    try {
//                        vm.model.lockedDelete = true;
//                        await productSettingService.delete(vm.model.edit.productsetting_keyno);
//                        stateService.back();
//                    } finally {
//                        vm.model.lockedDelete = false;
//                    }
//                }
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadProductTypes();
//                loadUnits();
//                loadProductGroups();
//                loadCompanies();
//                loadCompletionMethods();
//                loadCompletionPrinciples();
//                loadProductionOrderMethods();
//                loadPlanPolicies();
//                loadDiscGroupProducts();
//                loadProductionPlaces();

//                if (vm.model.edit.prodgrp_id > '') loadProductGroup2s();
//                if (vm.model.edit.prodgrp2_id > '') loadProductGroup3s();
//                if (vm.model.edit.prodgrp3_id > '') loadProductGroup4s();

//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
